// @ts-nocheck
/* eslint-disable */
export const uploadIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 17" fill="none"><path d="M14 3.83203L13.3333 2.49919L2.66667 2.49919L2 3.83203" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 5.46485L8 14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M4.66683 7.83203L8.00017 5.16536L11.3335 7.83203" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'upload' as const,
};
